import React from "react";

// Grouped list (iOS Settings), same layout as the POS detail screens
// (JournalDetailView / SaleDetailView): caption + card, edge to edge on
// phones, rounded card from md up. Rows have an inset divider.

export const Group = ({title, children, className = ""}) => (
    <section className={`mt-7 md:mx-4 ${className}`}>
        {title && <h3 className="mb-1.5 px-4 text-[13px] uppercase tracking-wide text-gray-500 dark:text-gray-400">{title}</h3>}
        <div className="bg-white dark:bg-gray-800 border-y md:border md:rounded-xl border-gray-200 dark:border-gray-700 overflow-hidden">
            <div className="pl-4">{children}</div>
        </div>
    </section>
);

// Divider between the rows of a Group (inset: starts after the 16px padding)
export const rowDivider = (first) => first ? "" : "border-t border-gray-200 dark:border-gray-700";

export const Row = ({label, sub, value, strong, first, leading, valueClass}) => (
    <div className={`flex items-center gap-2.5 min-h-[44px] py-2.5 pr-4 ${rowDivider(first)}`}>
        {leading}
        <span className="flex-1 min-w-0">
            <span className={`block truncate text-[15px] text-gray-900 dark:text-gray-100 ${strong ? "font-semibold" : ""}`}>{label}</span>
            {sub && <span className="block truncate text-xs text-gray-500 dark:text-gray-400">{sub}</span>}
        </span>
        {value !== undefined && value !== null && (
            <span className={`text-[15px] tabular-nums whitespace-nowrap ${valueClass || (strong ? "font-semibold text-gray-900 dark:text-gray-100" : "text-gray-500 dark:text-gray-400")}`}>
                {value}
            </span>
        )}
    </div>
);

// Round icon + label action (POS SaleDetailView action row)
export const RoundAction = ({icon: Icon, label, onClick, disabled, loading, danger}) => (
    <button type="button" onClick={onClick} disabled={disabled || loading}
            className="flex flex-col items-center gap-1.5 w-20 group disabled:opacity-50 disabled:cursor-not-allowed">
        <span className={`w-12 h-12 rounded-full flex items-center justify-center transition-colors ${
            danger ? "bg-red-500/10 text-red-600 group-hover:bg-red-500/20" : "bg-primary/10 text-primary group-hover:bg-primary/20"
        }`}>
            {loading ? <span className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin"/> : <Icon className="w-5 h-5"/>}
        </span>
        <span className={`text-xs text-center leading-tight ${danger ? "text-red-600" : "text-gray-700 dark:text-gray-300"}`}>{label}</span>
    </button>
);
